import { createSlice } from "@reduxjs/toolkit";
import * as lookupTnReducers from "../reducer/lookupTnReducers";

export interface LookupTnState {
  data: object[];
  isLoading: boolean;
}

const initialState: LookupTnState = {
  data: [],
  isLoading: false,
};

const lookupTnSlice = createSlice({
  name: "lookup-tn",
  initialState,
  reducers: { ...lookupTnReducers },
});

export const lookupTnActions = lookupTnSlice.actions;
export default lookupTnSlice;
